import React, { useEffect, useState } from 'react'
import './TimerComponent.css'
export default function TimerComponent({ time }) {

    const now = new Date();
    const targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const remainingTime = targetDate - new Date();


    const remainingSeconds = Math.floor((remainingTime / 1000) % 60);
    const remainingMinutes = Math.floor((remainingTime / 1000 / 60) % 60);
    const remainingHours = Math.floor((remainingTime / 1000 / 60 / 60) % 24);

    const [day, setDay] = useState(time - 1)
    const [hours, setHours] = useState(remainingHours);
    const [minutes, setMinutes] = useState(remainingMinutes);
    const [seconds, setSeconds] = useState(remainingSeconds);

    useEffect(() => {
        const interval = setInterval(() => {
            if (hours === 0 && minutes === 0 && seconds === 0) {
                if (day === 0) {
                    clearInterval(interval);
                    return;
                }
                setDay(day - 1);
                setHours(23);
                setMinutes(59);
                setSeconds(60);
            }

            if (minutes === 0 && seconds === 0) {
                setHours((prev) => prev - 1);
                setMinutes(59);
                setSeconds(59);
            } else if (seconds === 0) {
                setMinutes((prev) => prev - 1);
                setSeconds(59);
            } else {
                setSeconds((prev) => prev - 1);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [hours, minutes, seconds]);

    return (
        <div className='discount-timer'>
            <div className='day'>
                <span>{day}</span>
                روز
            </div>
            <div className='hour'>
                <span>{hours < 10 ? "0" + hours : hours}</span>
                ساعت
            </div>
            <div className='minut'>
                <span className='active'>{minutes < 10 ? "0" + minutes : minutes}</span>
                دقیقه
            </div>
            <div className='second'>
                <span>{seconds < 10 ? "0" + seconds : seconds}</span>
                ثانیه
            </div>
        </div>
    )
}
